export default "__VITE_ASSET__DdIqGUJQ__"